
export default {
  name: 'Illustration',
  props: ['data'],
}
